<prism-ui-page-content
  key-id="page-content"

  custom-max-width="680"
  >
  <div class="page-content u10g-eoia-web-ag" page-content >
  <prism-ui-heading
    key-id="heading-default"
    level="1"
    font-size="lg"
    font-weight="regular"
    is-uppercase="false"
    variant="default"
    >
    Authorization & Electronic Signature
  </prism-ui-heading>

      @if (showSuccessBanner) {
        <div class="successToast">
          <prism-ui-toast key-id="coverage-edit-saved-toast" action="close" size="large" variant="good" (prismUiToastOnClose)="onSuccessToastClose()">
            <div slot="heading">
              <prism-ui-heading key-id="coverage-edit-saved-toast-heading" font-size="xs" font-weight="strong" line-height="loose">
                Success
              </prism-ui-heading>
            </div>
            <prism-ui-copy slot="content" key-id="coverage-edit-saved-toast-content" line-height="loose">
              Your changes have been saved.
            </prism-ui-copy>
          </prism-ui-toast>
        </div>
      }

  <prism-ui-copy
    key-id="instructions-body"
    font-size="lg"
  >
    <p>***Please review the information below and submit your statement. If you think you've made a mistake in any of the sections below, please review them carefully before proceeding.***</p>
  </prism-ui-copy>
  <div class="wrapper">
        <app-overview>
        </app-overview>
        
        <app-auth-sign
        ></app-auth-sign>

        <app-electronic-communication
          (val)="submitApplication($event)"
          (submitAttempted)="onSubmitAttempt()"
          (cancelEmitter)="onCancel()"
          (backEmitter)="onCancel()"
          [showBackButton]="true"
          [externalValidationFn]="isAuthSignAcknowledgedBound"
        ></app-electronic-communication>
  </div>
</div>

</prism-ui-page-content>
